import { useContext } from 'react';
import { ISignalrContext } from './types';
import SignalrContext from './SignalrContext';

export const useSignalR = (): ISignalrContext => {
  const context = useContext(SignalrContext);

  if (!context) {
    throw new Error('This component must be a <SignalrProvider> component');
  }

  return context;
};
